/**
 * 告警规则、告警日志和模板配置reducer
 */
import { combineReducers } from 'redux'
import * as ACTIONS from '../actions/alarm_action'

function permissions(state = {}, action) {
    switch (action.type) {
        case ACTIONS.SET_PERMISSIONS:
            return action.permissions
        default:
            return state
    }
}
function alarmLogList(state = [], action) {//告警日志列表
    switch (action.type) {
        case ACTIONS.SET_ALARMLOGLIST:
            return action.alarmLogList
        default:
            return state
    }
}
function alarmLogCount(state = 0, action) {//告警日志总数
    switch (action.type) {
        case ACTIONS.SET_ALARMLOGCOUNT:
            return action.alarmLogCount
        default:
            return state
    }
}
function alarmNameList(state = [], action) {//告警名称列表
    switch (action.type) {
        case ACTIONS.SET_ALARMNAMELIST:
            return action.alarmNameList
        default:
            return state
    }
}
function alarmEquipment(state = [], action) {//报警设备列表
    switch (action.type) {
        case ACTIONS.SET_ALARMEQUIPMENT:
            return action.alarmEquipment
        default:
            return state
    }
}
function alarmRuleID(state = "", action) {//默认告警规则ID
    switch (action.type) {
        case ACTIONS.SET_ALARMRULEID:
            return action.alarmRuleID
        default:
            return state
    }
}
function alarmRuleList(state = [], action) {//告警规则列表
    switch (action.type) {
        case ACTIONS.SET_ALARMRULELIST:
            return action.alarmRuleList
        default:
            return state
    }
}
function alarmEventList(state = [], action){
    switch (action.type) {
        case ACTIONS.SET_ALARM_EVENTLIST:
            return action.alarmEventList
        default:
            return state
    }
}
function smsTemplate(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_SMSTEMPLATE:
            return action.smsTemplate
        default:
            return state
    }
}
function mailTemplate(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_MAILTEMPLATE:
            return action.mailTemplate
        default:
            return state
    }
}
function staff(state = [], action) {//默认单个告警规则数据相关的用户和接收人合集
    switch (action.type) {
        case ACTIONS.SET_STAFF:
            return action.staff
        default:
            return state
    }
}
function alarmRule(state = [], action) {//默认单个告警规则数据
    switch (action.type) {
        case ACTIONS.SET_ALARMRULE:
            return action.alarmRule
        default:
            return state
    }
}
function templeteList(state = [], action) {//模板列表
    switch (action.type) {
        case ACTIONS.SET_TEMPLATELIST:
            return action.templeteList
        default:
            return state
    }
}
function smsServerStatus(state = false, action) {//短息服务开启状态
    switch (action.type) {
        case ACTIONS.SET_SMSSERVERSTATUS:
            return action.smsServerStatus
        default:
            return state
    }
}

function alarmUsersList(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_ALARM_USERSLIST:
          return action.alarmUsersList
      default:
          return state
  }
}
function alarmUserTotal(state = 0, action) {
  switch (action.type) {
      case ACTIONS.SET_ALARM_USERSTOTAL:
          return action.alarmUserTotal
      default:
          return state
  }
}
function alarmSelectedUsers(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_ALARM_SELECTEDUSERS:
          return action.alarmSelectedUsers
      default:
          return state
  }
}
function mailSettings(state = {
  SendServer: "smtp.exmail.qq.com",
  MailAddress: "itossadmin@dragonflow.com",
  BackupSendServer: "smtp.exmail.qq.com",
  MailUserName: "itossadmin@dragonflow.com",
  MailPwd: "siteview123!@#"
}, action){
  switch (action.type) {
      case ACTIONS.SET_MAILSERVERSETTING:
          return action.mailSettings
      default:
          return state
  }
}
function smsSettings(state = {
  SMSUserName: "modem.com1",
  SMSPwd: "COM1",
  SMSLength: "9600",
  TaskPlanType: "wavecom",
  MouldId: "17254"
}, action){
  switch (action.type) {
      case ACTIONS.SET_SMSSENDSETTING:
          return action.smsSettings
      default:
          return state
  }
}

function alarmRuleSelectedEquipments(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_ALARMRULESELECTEDEQUIPMENTS:
          return action.alarmRuleSelectedEquipments
      default:
          return state
  }
}

function dutyData(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_DUTYDATA:
          return action.dutyData
      default:
          return state
  }
}

function profileData(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_PROFILEDATA:
          return action.profileData
      default:
          return state
  }
}

function userAlarmStaffMap(state = {}, action) {
  switch (action.type) {
      case ACTIONS.SET_USERALARMSTAFFMAP:
          return action.userAlarmStaffMap
      default:
          return state
  }
}

function profileMap(state = {}, action) {
  switch (action.type) {
      case ACTIONS.SET_PROFILEMAP:
          return action.profileMap
      default:
          return state
  }
}

function alarmLogs(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_ALARMLOGS:
          return action.alarmLogs
      default:
          return state
  }
}

function sendLogData(state = {list: [], total: 0, page: 1, pageSize: 20}, action) {
  switch (action.type) {
    case ACTIONS.SET_SENDLOGDATA:
      return action.sendLogData;
    default:
      return state;
  }
}

function allEquipments(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_ALLEQUIPMENTS:
          return action.allEquipments
      default:
          return state
  }
}

function eccMonitorList(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_ECCMONITORLIST:
          return action.eccMonitorList
      default:
          return state
  }
}

// 监测器实例下拉列表（value=monitorId），与 eccMonitorList 类型字典语义不同
function monitorOptions(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_MONITOROPTIONS:
          return action.monitorOptions
      default:
          return state
  }
}

function monitorItemsMap(state = {}, action) {
  switch (action.type) {
      case ACTIONS.SET_MONITORITEMSMAP:
          return action.monitorItemsMap
      default:
          return state
  }
}

const alarmReducer = combineReducers({
    permissions,
    alarmLogList,
    alarmLogCount,
    alarmNameList,
    alarmEquipment,
    alarmRuleID,
    alarmRuleList,
    alarmEventList,
    smsTemplate,
    mailTemplate,
    staff,
    alarmRule,
    templeteList,
    smsServerStatus,
    alarmUsersList,
    alarmUserTotal,
    alarmSelectedUsers,
    mailSettings,
    smsSettings,
    alarmRuleSelectedEquipments,
    dutyData,
    profileData,
    userAlarmStaffMap,
    profileMap,
    alarmLogs,
    sendLogData,
    allEquipments,
    eccMonitorList,
    monitorOptions,
    monitorItemsMap
})

export default alarmReducer
